module.exports = __webpack_public_path__ + "static/qckinetix-be454b94f2fe7bfaec21a3f569b49e7f.png";